import { NavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState, useRef } from "react";

const NavigationLink = ({
  to,
  state,
  label,
  icon,
  className = "",
  isCollapsed = false,
  tooltip,
  title,
  isActive,
  onClick,
}) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const [tooltipPosition, setTooltipPosition] = useState({ top: 0, left: 0 });
  const navLinkRef = useRef(null);

  const navigationTarget = (() => {
    if (to == null) return to;
    if (typeof to === "object") return to;
    const pathname = to.startsWith("/") ? to : `/${to}`;
    return state != null ? { pathname, state } : pathname;
  })();

  const tooltipText = tooltip || title || label;

  const handleMouseEnter = () => {
    if (isCollapsed && navLinkRef.current) {
      const rect = navLinkRef.current.getBoundingClientRect();
      setTooltipPosition({
        top: rect.top + rect.height / 2,
        left: rect.right + 10,
      });
      setShowTooltip(true);
    }
  };

  const handleMouseLeave = () => {
    if (isCollapsed) {
      setShowTooltip(false);
    }
  };

  return (
    <div style={{ position: "relative" }}>
      <NavLink
        className={`nav-link  ${isCollapsed ? "collapsed" : ""}`.trim()}
        activeClassName="nav-link-active"
        to={navigationTarget}
        title={isCollapsed ? tooltipText : title || ""}
        data-tooltip={isCollapsed ? tooltipText : ""}
        isActive={isActive}
        style={isCollapsed ? { position: "relative" } : {}}
        onClick={onClick}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        ref={navLinkRef}
      >
        {icon && (
          <FontAwesomeIcon icon={icon} className={`nav-icon ${className}`} />
        )}
        {!isCollapsed && <div>{label}</div>}
      </NavLink>

      {isCollapsed && showTooltip && (
        <div
          style={{
            position: "fixed",
            left: tooltipPosition.left,
            top: tooltipPosition.top,
            transform: "translateY(-50%)",
            backgroundColor: "#333333",
            color: "white",
            padding: "8px 12px",
            borderRadius: "6px",
            fontSize: "12px",
            whiteSpace: "nowrap",
            zIndex: 99999,
            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.3)",
            pointerEvents: "none",
          }}
        >
          {tooltipText}
          <div
            style={{
              position: "absolute",
              left: "-5px",
              top: "50%",
              transform: "translateY(-50%)",
              border: "5px solid transparent",
              borderRightColor: "#333333",
            }}
          />
        </div>
      )}
    </div>
  );
};

export default NavigationLink;
